import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './lang';
import VueLayers from 'vuelayers';
import BootstrapVue from 'bootstrap-vue';
import Vue2TouchEvents from 'vue2-touch-events';
import vSelect from 'vue-select';
import Vuetify from 'vuetify';
import Global from "./plugins/global.js";

// import DaySpanVuetify from 'dayspan-vuetify';

import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/es.es.js'
import 'vue-cal/dist/vuecal.css'

import VueQrcodeReader from "vue-qrcode-reader";


Vue.use(VueQrcodeReader);

/*________CSS________*/
//import '@/assets/css/bootstrap.css';
import '@/assets/css/icons/icomoon/styles.css';
//import '@/assets/css/core.css';
//import '@/assets/css/components.css';
//import '@/assets/css/colors.css';
import '@/assets/css/jqx.base.css';
import '@/assets/css/jqx.custom.css';
//import '@/assets/css/all.css';
import '@/assets/css/draggableGrid.css';


/*___________citaprevia________*/

import 'vuetify/dist/vuetify.min.css'
 //import 'material-design-icons-iconfont/dist/material-design-icons.css'
//import 'dayspan-vuetify/dist/lib/dayspan-vuetify.min.css'

// import es from 'dayspan-vuetify/src/locales/es';

/*____________tienda____________*/
import '@/assets/css/unifilter.css';
import '@/assets/css/unishop.css';
import VueMasonry from 'vue-masonry-css'

/*______controlusuarios_____*/
//import '@/assets/css/card.css'
import '@/assets/css/tabs.css'
//import '@/assets/css/main.css'
import '@/assets/css/main_styles.css'
import '@/assets/css/calendar.css'

/*________JS________*/
import '@/assets/js/core/libraries/jquery.min.js';
import '@/assets/js/core/libraries/bootstrap.min.js';
import '@/assets/js/plugins/ui/nicescroll.min.js';
import '@/assets/js/core/app.js';

import 'vue-select/dist/vue-select.css';
import './registerServiceWorker'


// Usaremos Node para detectar la concurrencia de usuarios

import VueSocketIO from 'vue-socket.io';
import SocketIO from 'socket.io-client'

Vue.config.productionTip = false;
Vue.use(require('vue-cookies'));
Vue.use(VueLayers);
Vue.use(BootstrapVue);
Vue.use(Vue2TouchEvents);
Vue.use(Vuetify, {
  theme: {
    primary: '#336699',
}});
Vue.use(VueMasonry);
Vue.use(Global);

Vue.use( 
  new VueSocketIO({
      debug: true,
      connection: SocketIO(process.env.NODE_ENV === 'development' || window.location.origin.includes('localhost') ? 'http://localhost:3650' : 'wss://servicios.yet.es', 
      {
        path: process.env.NODE_ENV === 'development' || window.location.origin.includes('localhost') ? '' : ''
      }
      ),
      extraHeaders: {
        'Access-Control-Allow-Credentials': true
      },
      allowEIO3: true
      
  })
)
// Vue.use(DaySpanVuetify, {
//   methods: {
//     getDefaultEventColor: () => '#1976d2'
//   }
// });
// Vue.$dayspan.addLocales(['es', 'es-ES'], es);

Vue.component('vue-select', vSelect);

Vue.component('VueCal', VueCal);


// Hack para que se ciere el sidebar al clickar fuera
Vue.directive('click-outside', {
  bind(el, binding, vnode) {
      var vm = vnode.context;
      var callback = binding.value;

      el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
              return callback.call(vm, event);
          }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');